<style lang="stylus">
    .rightclickmenu-mindmap2
        .ft-menu
            cursor pointer
            .ft-menutext
                font-size 14px
        floatTool_dropbox()
</style>

<template>
    <div class="rightclickmenu-mindmap2">
        <AIFloatMenuPictureAnalysis :fromType="'rightClickMenu'" />
        <div class="ft-aigray-text" :class="{ 'ft-h-divided': !internal }">
            <p>{{ $t("AIText") }}</p>
        </div>
        <FtMenu :imgIcon="'ai-text-summary'" :text="$t('textSummary')" @clickMenu="mindmapSummary()" />
    </div>
</template>

<script lang="ts">
    import { Component } from "vue-property-decorator";
    import FtMenu from "@/app/components/FloatTool/public/FtMenu.vue";
    import AiSocket from "@/app/mixin/aiSocket";
    import AIFloatMenuPictureAnalysis from "@/app/components/FloatTool/AIFloatMenuPictureAnalysis.vue";

    @Component({
        components: {
            FtMenu,
            AIFloatMenuPictureAnalysis,
        },
    })
    export default class AiMindmap2 extends AiSocket {
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }
        aiPromise(...args) {
            if (this.noLoginEditor) {
                return this.generatingNologin(...args);
            } else {
                return this.generating(...args);
            }
        }
        markdownData() {
            if (!window["_view"]) return "";
            return window["_view"].getShapeMarkdownData();
        }
        mindmapSummary() {
            const prompt = this.markdownData();
            window["_view"].AICreateSummary();
            this.aiPromise("mindmap-summary", { prompt }).then(() => {
                window["_view"].replacePlainTextNoAction(this.resultText);
            });
        }
        created() {
            !this.noLoginEditor && this.initAiSocket();
        }
    }
</script>
<i18n>
{
    "zh": {
        "AIText": "文本分析",
        "textSummary": "智能总结"
    },
    "en": {
        "AIText": "Text Analysis",
        "textSummary": "Smart Summary"
    },
    "de": {
        "AIText": "Textanalyse",
        "textSummary": "Zusammenfassung"
    },
    "es": {
        "AIText": "Análisis de texto",
        "textSummary": "Resumen"
    },
    "fr": {
        "AIText": "Analyse de texte",
        "textSummary": "Résumé"
    },
    "it": {
        "AIText": "Analisi testo",
        "textSummary": "Riepilogo"
    },
    "jp": {
        "AIText": "テキスト分析",
        "textSummary": "要約"
    },
    "pt": {
        "AIText": "Análise de texto",
        "textSummary": "Resumo"
    },
    "tw": {
        "AIText": "文字分析",
        "textSummary": "摘要"
    },
    "kr": {
        "AIText": "텍스트 분석",
        "textSummary": ""
    }
}
</i18n>
